<script>
    export let src = '';
    export let alt = 'Image';
    
    if (src.includes('/uploads/')) {
        src = '/crop?imaginary=true&url=' + location.origin + '/' + src + '&width=500&height=450&quality=85&compression=7'
    }
</script>

<img src="{src}" alt="{alt}" {...$$restProps} />
